<template>
  <div id="ecommerce_product">
    <div v-if="state == 'list'">
      <v-container>
        <div>
          <v-layout wrap>
            <v-flex xs12 sm12 class="form-control pa-2 text-xs-center text-sm-right">
              <input
                type="text"
                class="form-control ma-0"
                v-model="search"
                style="display: inline-block; max-width: 300px"
                :placeholder="$t('Search')"
                v-if="categorylist && categorylist.length > 0 && productlist.length > 0"
              />
              <!-- <transfer-shop style="display: inline-block"></transfer-shop> -->
            </v-flex>
          </v-layout>
        </div>
        <template v-if="loadingCategory">
          <div style="padding: 30px 0">
            <scale-loader :color="$vuetify.theme.primary" height="45px" width="7px"></scale-loader>
          </div>
        </template>
        <template v-else-if="categorylist && categorylist.length == 0">
          <v-layout wrap>
            <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
              <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 230px" />
              <h3 class="headline">{{ $t('create your first category') }}</h3>
              <p>{{ $t('Click Add Category to create a category and add products') }}</p>
              <v-btn color="primary" depressed @click="showCategory = true">
                <em class="fa fa-plus middle mr-1" />
                {{ $t('Add new categories') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <v-layout wrap>
            <v-flex xs5>
              <h3 class="headline mt-2">{{ $t('Category') }}</h3>
            </v-flex>
            <v-flex xs7 text-xs-right>
              <v-btn
                small
                fab
                outline
                class="primary--text"
                @click="showCategory = true"
                v-if="
                  !(
                    selectedBot.useketshop == true &&
                    selectedBot.ketshop_api_key &&
                    selectedBot.ketshop_api_secret
                  )
                "
              >
                <em class="fa fa-pencil-alt middle" />
              </v-btn>
            </v-flex>
          </v-layout>
          <div style="overflow-x: auto; white-space: nowrap; padding-bottom: 15px">
            <filter-category
              :categories="categorylist"
              v-model="currentCategory"
              @onChangeCategory="onChangeCategory"
              :stat="filterBadge"
              :isAppend="selectedBot.theme == 'nvbb'"
            ></filter-category>
          </div>
          <div>
            <template>
              <v-layout wrap>
                <template v-if="currentCategory !== 'all'">
                  <v-flex xs12 text-xs-left>
                    <filter-category
                      :categories="memberLevelList"
                      v-model="memberLevel"
                      @onChangeSubCategory="onChangeMemberLevel"
                      :stat="filterBadge"
                      :hasAll="false"
                    ></filter-category>
                  </v-flex>
                </template>
              </v-layout>
            </template>
          </div>

          <v-divider class="my-3"></v-divider>
          <template v-if="currentCategory && currentCategory != null">
            <v-layout warp>
              <v-flex xs12 sm6>
                <h3 class="headline mt-3">{{ $t('Products') }}</h3>
              </v-flex>
              <v-flex xs12 sm6 class="text-xs-right">
                <v-btn outline color="primary" @click="showSortProduct = true">
                  <v-icon class="mr-2">swap_vert</v-icon>
                  {{ $t('sort product') }}
                </v-btn>
                <sort-product
                  v-if="showSortProduct"
                  v-model="showSortProduct"
                  :key="timestamp"
                  @onChangeProduct="onChangeProduct"
                ></sort-product>
              </v-flex>
            </v-layout>

            <template v-if="!loadingProduct">
              <v-layout wrap v-if="categorylist && filterProducts && filterProducts.length > 0">
                <v-flex xs12 sm1>
                  <v-select
                    :items="pagelimit"
                    solo
                    v-model="size"
                    @change="onChangeLimit"
                    small
                    class="browser-default mb-2"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                  <v-pagination
                    v-model="pageNumber"
                    :length="pageCount"
                    @input="onClickPageinate"
                    class="mb-2"
                  ></v-pagination>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex
                  xs12
                  sm6
                  md4
                  lg3
                  xl2
                  class="pa-1"
                  v-if="
                    !(
                      selectedBot.useketshop == true &&
                      selectedBot.ketshop_api_key &&
                      selectedBot.ketshop_api_secret
                    )
                  "
                >
                  <div
                    class="btn-add"
                    @click="onAddNewProduct"
                    style="position: relative; min-height: 360px; cursor: pointer; height: 100%"
                  >
                    <div style="position: absolute; top: 50%; margin-top: -30px; left: 0; right: 0">
                      <div class="text-xs-center">
                        <h3 class="headline" style="color: #969595">
                          <em class="fa fa-plus" />
                        </h3>
                        <p>{{ $t('Add new product') }}</p>
                      </div>
                    </div>
                    <template
                      v-if="
                        ($store.getters.getPackage != 'premium' || isCoachlab) &&
                        productlist.length >= maxProduct
                      "
                    >
                      <v-premium-plan-popup
                        :showAll="false"
                        marginTop="65"
                        :size="'small'"
                      ></v-premium-plan-popup>
                    </template>
                  </div>
                </v-flex>
                <template v-if="categorylist && filterProducts && filterProducts.length > 0">
                  <template v-for="(product, index) in filterProducts">
                    <v-flex xs12 sm6 md4 lg3 xl2 class="pa-1" :key="'product_' + product.id">
                      <product
                        @changeproductstatus="onChangeProductStatus"
                        v-model="filterProducts[index]"
                        @productDeleted="onDeleteProduct(index)"
                        :page="'promotion'"
                        :category="categorylist"
                        :selectCategory="currentCategory"
                        @onSelectedProduct="onSelectedProduct(index, product)"
                      ></product>
                    </v-flex>
                  </template>
                </template>
              </v-layout>

              <v-layout
                wrap
                v-if="categorylist && filterProducts && filterProducts.length > 0"
                class="mt-3"
              >
                <v-flex xs12 sm1>
                  <v-select
                    :items="pagelimit"
                    solo
                    v-model="size"
                    @change="onChangeLimit"
                    small
                    class="mb-2"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                  <v-pagination
                    v-model="pageNumber"
                    :length="pageCount"
                    @input="onClickPageinate"
                    class="mb-2"
                  ></v-pagination>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <div style="padding: 30px 0">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="45px"
                  width="7px"
                ></scale-loader>
              </div>
            </template>
            <div class="mb-5 mt-5"></div>
          </template>
          <template v-else>
            <div class="text-xs-center" style="margin: 35px 0">
              <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 300px" />
              <h3 class="headline">{{ $t('Select category') }}</h3>
              <v-btn depressed color="primary" @click="showCategory = true">
                {{ $t('Add new categories') }}
              </v-btn>
            </div>
          </template>
        </template>
        <categories
          v-model="categorylist"
          @close="showCategory = false"
          :show="showCategory"
          @onCategoryChange="onCategoryChange"
          @deleteCategory="deleteCategory"
        ></categories>
      </v-container>
    </div>
    <div v-else-if="state == 'add-product'">
      <template v-if="categorylist && state == 'add-product'">
        <v-container>
          <modal-promotion
            :selectCategory="currentCategory"
            :category="categorylist"
            @onAddProduct="addProduct"
            @close="close"
          ></modal-promotion>
        </v-container>
      </template>
    </div>
    <div v-else-if="state == 'edit-product'">
      <template v-if="categorylist && currentProduct">
        <v-container>
          <modal-promotion
            :editData="currentProduct"
            :selectCategory="currentCategory"
            :category="categorylist"
            @onSaveProduct="closeEditProduct"
            @close="close"
          ></modal-promotion>
        </v-container>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Product from './Product'
import ModalEditProduct from '@/components/view/template/ecommerce/ModalEditProduct'
import SelectCategory from '@/components/view/template/ecommerce/SelectCategory'
import FilterCategory from './FilterCategory'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import Categories from '@/components/view/template/ecommerce/Categories'
import ModalHelp from '@/components/elements/ModalHelp'
import TransferShop from '@/components/view/template/ecommerce/TransferShop.vue'
import SortProduct from '@/components/view/template/ecommerce/SortProduct.vue'
import moment from 'moment'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import ImportShop from '@/components/view/template/ecommerce/ImportShop.vue'
import ModalPromotion from './ModalPromotion.vue'
import XLSX from 'xlsx'

import api from '@/api'

export default {
  data: function () {
    return {
      showSortProduct: false,
      pageNumber: 1,
      size: 10,
      currentProduct: undefined,
      currentCategory: 'all',
      currentFilter: 'all',
      productlist: [],
      categorylist: undefined,
      selectedProduct: null,
      showCategory: false,
      showModal: false,

      loadingProduct: true,
      loadingCategory: true,
      exportscgloading: false,
      pagelimit: [10, 25, 50],

      filterBadge: {
        all: 0,
        sales: 0,
        soldout: 0
      },

      productCount: 0,

      search: '',
      state: 'list',
      timestamp: moment().format('x'),
      memberLevelList: [
        { id: 1, name: 'New Member', value: 'new' },
        { id: 2, name: 'Silver Member', value: 'silver' },
        { id: 3, name: 'Gold Member', value: 'gold' }
      ],
      memberLevel: null
    }
  },
  components: {
    Product,
    ModalPromotion,
    ImportShop,
    ModalEditProduct,
    Categories,
    SelectCategory,
    ScaleLoader,
    FilterCategory,
    ModalHelp,
    TransferShop,
    SortProduct
  },
  mounted: function () {
    let vm = this
    // vm.$store.dispatch("loading")
    vm.getCategories(function () {
      if (vm.categorylist.length > 0) {
        vm.onChangeCategory(vm.categorylist[0])
      }
      vm.getProducts().then(() => {
        vm.loadingCategory = false
      })
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      isFacebook: 'isFacebook'
    }),
    maxProduct() {
      return this.isCoachlab ? 20 : 10
    },
    currentMemberLevel() {
      if (this.memberLevel) {
        var currentMember = this.memberLevelList.filter((x) => {
          if (x.id === this.memberLevel) {
            return x
          }
        })

        return currentMember[0].value
      } else {
        return ''
      }
    },
    filterProducts: function () {
      let products = []
      let vm = this
      vm.filterBadge = {
        all: vm.productlist.length,
        sales: 0,
        soldout: 0
      }

      $.each(vm.productlist, function (index, val) {
        if (vm.currentCategory === val.categoryid) {
          if (vm.currentMemberLevel) {
            if (vm.currentMemberLevel === val.producttype) {
              products.push(val)
            }
          } else {
            products.push(val)
          }
        }
      })
      if (vm.currentCategory === 'all') {
        products = vm.productlist
      }

      var p = []
      if (vm.search === '') {
        p = products
      } else {
        p = products.filter((product) => {
          var isFoundSkuInStock = false
          if (product.productstock && product.productstock.length > 0) {
            var stocks = product.productstock.filter((stock) => {
              return (
                stock[5] &&
                stock[5] != null &&
                stock[5].toLowerCase().includes(vm.search.toLowerCase())
              )
            })
            isFoundSkuInStock = stocks.length > 0
          }
          return (
            product.name.toLowerCase().includes(vm.search.toLowerCase()) ||
            (product.code != null &&
              product.code.toLowerCase().includes(vm.search.toLowerCase())) ||
            isFoundSkuInStock
          )
        })
      }
      this.productCount = p.length

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return p.slice(start, end)
    },
    pageCount: function () {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  methods: {
    exportAkita() {
      var dataWS = null
      var json = this.productlist.map((product) => {
        var photourl = []
        try {
          if (product.photourl != '') photourl = product.photourl.split(';;')
        } catch (error) {}

        var variants = []

        try {
          variants = JSON.parse(product.productstockcategories)
        } catch (error) {}
        if (variants.length == 0) variants = [{ level: 0, name: 'ตัวเลือก' }]

        if (photourl.length == 0) {
          photourl[0] =
            'https://zwizai.s3.amazonaws.com/ecommerce/1583138880495image-not-found-big-300x169.png'
        }
        return product.productstock.map((stock) => {
          var stock_variants = []
          var price = 0

          if (stock[4]) {
            price = stock[4]
          } else if (stock[3]) {
            price = stock[3]
          } else if (product.discountprice) {
            price = product.discountprice
          } else {
            price = product.price
          }
          try {
            stock_variants = stock[1].split('/')
          } catch (error) {}
          return {
            code: product.code,
            name: product.name,
            description: product.description,
            variant1: variants[0].name,
            variant2: variants.length > 1 ? variants[1].name : '',
            brand: '',
            photo1: photourl[0],
            photo2: photourl[1] ? photourl[1] : '',
            photo3: photourl[2] ? photourl[2] : '',
            photo4: photourl[3] ? photourl[3] : '',
            photo5: photourl[4] ? photourl[4] : '',
            'sku.code': stock[5],
            'sku.barcode': '',
            'sku.variant1': stock_variants[0],
            'sku.variant2': stock_variants.length > 1 ? stock_variants[1] : '',
            'sku.cost': '',
            'sku.price': price
          }
        })
      })
      json = [].concat(...json)

      dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwiz-product.xlsx')
    },
    async close() {
      this.state = 'list'
      await this.$nextTick()
      goTo(0)
    },
    async onChangeProduct() {
      await this.getProducts()
      this.timestamp = moment().format('x')
    },
    onChangeLimit: function (value) {
      this.size = value
      this.pageNumber = 1
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onClickPageinate: function (pageNum) {
      this.pageNumber = pageNum
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onAddNewProduct: function () {
      var vm = this
      if (
        (vm.$store.getters.getPackage === 'premium' && !vm.isCoachlab) ||
        (vm.$store.getters.getPackage !== 'premium' && vm.productlist.length < vm.maxProduct) ||
        (vm.isCoachlab && vm.productlist.length < vm.maxProduct)
      ) {
        vm.state = 'add-product'
      }
      this.timestamp = moment().format('x')
    },
    closeEditProduct: async function () {
      var vm = this
      await vm.getProducts()
      // vm.$store.dispatch('loading')
      vm.state = 'list'
      this.timestamp = moment().format('x')
    },
    onSelectedProduct: function (index, product) {
      this.currentProduct = product
      this.state = 'edit-product'
    },
    onCategoryChange: function () {
      let vm = this
    },
    deleteCategory(categoryid) {
      this.productlist = this.productlist.filter((el) => {
        return el.categoryid != categoryid
      })
      if (this.currentCategory == categoryid) {
        this.setDefaultCategory()
      }
    },
    getCategories: function (callback) {
      let vm = this
      vm.loadingCategory = true
      if (!vm.selectedBot) {
        return
      }
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getCategories(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.categorylist = response.categorylist
        callback()
      })
    },
    getProducts: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        if (!vm.selectedBot) {
          reject()
        }
        let data = {
          pageid: vm.selectedBot.pageid
        }
        vm.loadingProduct = true
        vm.productlist = []

        api.getProducts(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.loadingProduct = false
            resolve()
            return
          }
          vm.productlist = response.productlist
          vm.loadingProduct = false
          resolve()
        })
      })
    },
    async addProduct() {
      await this.getProducts()
      this.timestamp = moment().format('x')
    },
    onSelectProduct: function (val) {
      this.selectedProduct = this.productlist.find((product) => {
        return product.id == val
      })
    },
    onLoadCategory: function (payload) {
      // console.log(payload)
      if (payload && payload.length > 0) {
        // this.getProducts()
      }
    },
    onChangeCategory: function (payload) {
      this.setDefaultCategory()
      this.currentFilter = 'all'
      this.search = ''
      this.pageNumber = 1
      // this.getProducts()
    },
    onChangeMemberLevel: function (payload) {
      this.setDefaultMemberLevel()
      // this.currentFilter = 'all'
      this.search = ''
      this.pageNumber = 1
      // this.getProducts()
    },
    onDeleteProduct: function (index) {
      // vm.productlist.splice(index,1)
      this.getProducts()
      this.timestamp = moment().format('x')
    },
    onChangeProductStatus(payload) {
      var index = this.productlist.findIndex((el) => {
        return payload.id == el.id
      })
      this.$set(this.productlist[index], 'status', payload.status)
    },
    setDefaultCategory() {
      if (this.selectedBot.theme == 'nvbb' && this.categorylist.length > 0) {
        this.currentCategory = this.categorylist[0].id
      } else {
        this.currentCategory = 'all'
      }
    },
    setDefaultMemberLevel() {
      if (this.memberLevelList.length > 0) {
        this.currentMemberLevel = this.memberLevelList[0].value
      } else {
        this.currentMemberLevel = ''
      }
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    },
    showModal: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    showCategory: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    currentCategory: function (newVal, oldVal) {
      if (newVal != null) {
        this.pageNumber = 1
        this.memberLevel = ''
        // this.getProducts(function() {})
      }
    },
    currentMemberLevel: function (newVal, oldVal) {
      if (newVal != null) {
        this.pageNumber = 1
        // this.getProducts(function() {})
      }
    },
    productlist: function (newVal, oldVal) {
      let vm = this
      // $.each(vm.productlist,function(index ,val){
      // 	if (val.categoryid != vm.currentCategory.id) {
      // 		vm.productlist.splice(index,1)
      // 		return false;
      // 	}
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.ketshop-bg-color {
  background-color: rgb(58, 58, 58);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/Promotions.vue